import { v4 as uuid } from 'uuid';
import { epoch, formatEpochAsDate, utc } from '../../util/datetime';
import { toUUID } from '../../util/transform';
import type { IContactPersonDependent } from './ContactPersonDependent.interface';

export default class ContactPersonDependent implements IContactPersonDependent {
  id: string;
  name: string;
  dateOfBirth: number;

  getDependentDateOfBirth(timeZone, locale, localeFormat) {
    return formatEpochAsDate(this.dateOfBirth, timeZone, locale, localeFormat);
  }

  static build = (data: IContactPersonDependent) => new ContactPersonDependent(data);
  static blank = () => new ContactPersonDependent({ id: uuid() });

  /**
   * Constructor
   * @param {IContactPersonDependent} data
   */
  constructor(data?: IContactPersonDependent) {
    this.id = toUUID(data?.id) || uuid();
    this.name = data?.name || '';
    this.dateOfBirth = data?.dateOfBirth ? epoch(utc(data?.dateOfBirth)) : 0;
  }
}
